import React, { useEffect, useState } from 'react';
import { Loader2, UserPlus } from 'lucide-react';
import { atlasApi, AtlasUser } from '../shared/atlasApi';

interface Props {
  user: AtlasUser;
}

interface Indicacao {
  candidato: { nome: string; etapa: string; enviado_em: string | null };
  vaga: { id: string; titulo?: string };
}

const ETAPA_LABEL: Record<string, string> = {
  triagem: 'Triagem', entrevista_rh: 'Entrevista RH', entrevista_gestor: 'Entrevista Gestor',
  teste: 'Teste', proposta: 'Proposta', aprovado: 'Aprovado', reprovado: 'Reprovado', desistiu: 'Desistiu',
};

function fdata(s?: string | null) {
  if (!s) return '—';
  try { return new Date(s).toLocaleDateString('pt-BR'); } catch { return s; }
}

const MinhasIndicacoes: React.FC<Props> = ({ user }) => {
  const [itens, setItens] = useState<Indicacao[]>([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState<string | null>(null);

  useEffect(() => {
    let cancel = false;
    atlasApi.minhasIndicacoes(user)
      .then(r => { if (!cancel) setItens(r.itens || []); })
      .catch(e => { if (!cancel) setErro(e.message || 'Erro ao carregar'); })
      .finally(() => { if (!cancel) setLoading(false); });
    return () => { cancel = true; };
  }, [user]);

  if (loading) return <div className="p-10 text-center text-gray-400"><Loader2 className="w-6 h-6 animate-spin mx-auto mb-2" /> Carregando...</div>;
  if (erro) return <div className="bg-rose-50 border border-rose-200 rounded-2xl p-6 text-rose-700">{erro}</div>;

  return (
    <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
      <div className="px-4 py-3 border-b border-gray-100 flex items-center gap-2">
        <UserPlus className="w-4 h-4 text-purple-600" />
        <h3 className="font-bold text-gray-900 text-sm">Minhas indicações</h3>
      </div>
      {itens.length === 0 ? (
        <div className="p-8 text-center text-gray-400 text-sm">Você ainda não indicou candidatos.</div>
      ) : (
        <ul className="divide-y divide-gray-100">
          {itens.map((it, i) => (
            <li key={i} className="px-4 py-3 flex items-center gap-3">
              <div className="flex-1 min-w-0">
                <div className="font-medium text-gray-900 truncate">{it.candidato.nome}</div>
                <div className="text-xs text-gray-400">{it.vaga.titulo || 'Vaga'} · indicado em {fdata(it.candidato.enviado_em)}</div>
              </div>
              <span className="px-2 py-0.5 rounded-full text-[11px] font-medium bg-purple-100 text-purple-700">{ETAPA_LABEL[it.candidato.etapa] || it.candidato.etapa}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default MinhasIndicacoes;
